import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/system/Box";
import PrimaryCheckbox from "../../../Inputs/PrimaryCheckBox/PrimaryCheckBox";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function SelectedCell({ row, column, updateData }) {
  const selected = nullCheck(row, false, "original", "selected");
  const active = nullCheck(row, false, "original", "activeRow");

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", margin: "-4px 0 0 9px" }}
      onClick={(e) => e.stopPropagation()}>
      <PrimaryCheckbox
        checked={selected}
        handleChange={(e) => {
          e.stopPropagation();
          updateData(row.index, column.id, e.target.checked);
        }}
        color={active ? "white_opacity.100" : ""}
      />
    </Box>
  );
}

SelectedCell.propTypes = {
  row: PropTypes.object,
  column: PropTypes.object,
  updateData: PropTypes.func
};